import { createVanIconComponent } from "./van"

const Friends = createVanIconComponent("friends")
export default Friends
